import { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAuth } from '../../redux/modules/auth/selectors';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SocketListener from '../../utils/SocketListener';
import SocketNotificationTypes from '../../utils/SocketNotificationTypes';
import { useStyles } from './InAppNotification.styles';

const InAppNotification = () => {
  const classes = useStyles();
  const [state, setState] = useState({
    open: true,
    vertical: 'top',
    horizontal: 'right',
    notificationData: {},
  });

  const { vertical, horizontal } = state;

  const { inAppNotification } = useSelector(storeState => storeState.socket);
  const { isAuthenticated } = useSelector(getAuth);
  const matchString = 'new message received in group';
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const action = (
    <Fragment>
      <IconButton size="small" aria-label="close" color="primary" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  const handleClick = () => {
    let clickListener;
    switch (state.notificationData.notificationType) {
      case SocketNotificationTypes.chatMessageReceived:
      case SocketNotificationTypes.groupMessageReceived:
        clickListener = SocketListener.createMessageNoitificationClickListener(state.notificationData);
        if (clickListener !== null) {
          clickListener();
        }
        break;
      case SocketNotificationTypes.appointmentRequested:
        clickListener = SocketListener.createAppointmentRequestedNotificationListener(state.notificationData);
        clickListener();
        break;
      case SocketNotificationTypes.appointmentNeedsAction:
        clickListener = SocketListener.createAppointmentNeedsActionNotificationListener(
          state.notificationData,
        );
        clickListener();
        break;
      case SocketNotificationTypes.appointmentConfirmed:
        clickListener = SocketListener.createAppointmentConfirmedNotificationListener(state.notificationData);
        clickListener();
        break;
      case SocketNotificationTypes.appointmentCancelled:
        clickListener = SocketListener.createAppointmentCancelledNotificationListener(state.notificationData);
        clickListener();
        break;
      default:
        break;
    }
    handleClose();
  };

  useEffect(() => {
    if (inAppNotification) {
      setState({ ...state, notificationData: inAppNotification.data, open: inAppNotification.open });
    }
  }, [inAppNotification]);

  function truncate(str, n) {
    return str.length > n ? `${str.slice(0, n - 1)}...` : str;
  }

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={isAuthenticated && state.open}
        key={vertical + horizontal}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <div className={classes.root}>
          <div className={classes.message} onClick={handleClick}>
            <div className={classes.title}>
              {state.notificationData?.title ? truncate(state.notificationData.title, 40) : ''}
            </div>
            <div className={classes.subtitle}>
              {state?.notificationData?.title &&
                state?.notificationData?.title?.toLowerCase()?.includes(matchString) && (
                  <span style={{ fontWeight: 700 }}>{state?.notificationData?.metadata?.senderName}: </span>
                )}
              {state.notificationData?.subtitle ? truncate(state.notificationData.subtitle, 30) : ''}
            </div>
          </div>
          {action}
        </div>
      </Snackbar>
    </div>
  );
};

export { InAppNotification };
